<template>
    <v-divider :thickness="item.thickness || 5" :color="item.color || 'black'"></v-divider>
  </template>
  
  <script setup>
    import { defineProps } from 'vue';
  const props = defineProps({
    item: Object
  });
  </script>
  